import { combineReducers, configureStore } from "@reduxjs/toolkit";
import ordersReducer from "./slices/orders-slice";
import loginReducer from "./slices/login-slice";
import registrationReducer from "./slices/register-slice";
import newOrderReducer from "./slices/new-order-slice";
import staticDataReducer from "./slices/static-data.slice";
import recipientsReducer from "./slices/recipients.slice";
import userAddressesReducer from "./slices/user-addresses.slice";
import messagesReducer from "./slices/messages.slice";
import sidebarReducer from "./slices/sidebar.slice";
import actionbarReducer from "./slices/actionbar.slice";
import deviceReducer from "./slices/device.slice";
import balanceReducer from "./slices/balance-slice";
import userUploadsReducer from "./slices/user-uploads.slice";
import userNotificationsReducer from "./slices/user-notifications.slice";
import currentUserReducer from "./slices/current-user.slice";
import orderGroupReducer from "./slices/order-group.slice";
import CRMReducer from "./slices/crm.slice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const combinedReducer = combineReducers({
  ordersReducer: ordersReducer,
  registrationReducer: registrationReducer,
  loginReducer: loginReducer,
  newOrderReducer: newOrderReducer,
  staticDataReducer: staticDataReducer,
  recipientDataReducer: recipientsReducer,
  userAddressesReducer: userAddressesReducer,
  messagesReducer: messagesReducer,
  sidebarReducer: sidebarReducer,
  actionbarReducer: actionbarReducer,
  deviceReducer: deviceReducer,
  balanceReducer: balanceReducer,
  userUploadsReducer: userUploadsReducer,
  userNotificationsReducer: userNotificationsReducer,
  currentUserReducer: currentUserReducer,
  CRMReducer: CRMReducer,
  orderGroupReducer: orderGroupReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "login/logOutAction") {
    const newState = { ...state };

    // TODO: check resetting reducers
    newState.ordersReducer = undefined;
    newState.registrationReducer = undefined;
    newState.loginReducer = undefined;
    newState.newOrderReducer = undefined;
    newState.recipientDataReducer = undefined;
    newState.sidebarReducer = undefined;
    newState.actionbarReducer = undefined;
    newState.balanceReducer = undefined;
    newState.userUploadsReducer = undefined;
    newState.balanceReducer = undefined;
    newState.currentUserReducer = undefined;
    newState.CRMReducer = undefined;
    newState.orderGroupReducer = undefined;

    return combinedReducer(newState, action);
  } else {
    return combinedReducer(state, action);
  }
};

export const store = configureStore({
  reducer: rootReducer,
  // middleware: [...getDefaultMiddleware()] TODO: check if necessary
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<
  ReturnType<typeof store.getState>
> = useSelector;
